import createSvgIcon from "@material-ui/icons/utils/createSvgIcon";
import React from "react";

const Sun = createSvgIcon(
  <>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.6363 5V7.54545H11.3636V5H12.6363ZM11.9999 13.9091C13.0543 13.9091 13.909 13.0544 13.909 12C13.909 10.9456 13.0543 10.0909 11.9999 10.0909C10.9456 10.0909 10.0908 10.9456 10.0908 12C10.0908 13.0544 10.9456 13.9091 11.9999 13.9091ZM11.9999 15.1818C13.7572 15.1818 15.1817 13.7573 15.1817 12C15.1817 10.2427 13.7572 8.81818 11.9999 8.81818C10.2427 8.81818 8.8181 10.2427 8.8181 12C8.8181 13.7573 10.2427 15.1818 11.9999 15.1818ZM14.6998 8.40019L15.5997 9.30014L17.3996 7.50023L16.4997 6.60028L14.6998 8.40019ZM12.6363 16.4545V19H11.3636V16.4545H12.6363ZM6.60019 16.4998L7.50015 17.3997L9.30006 15.5998L8.4001 14.6999L6.60019 16.4998ZM14.6999 15.5998L15.5999 14.6998L17.3998 16.4997L16.4998 17.3997L14.6999 15.5998ZM6.60025 7.5002L8.40016 9.3001L9.30012 8.40015L7.50021 6.60024L6.60025 7.5002ZM19 12.6363H16.4545L16.4545 11.3636H19V12.6363ZM5 12.6364L7.54545 12.6364V11.3637H5V12.6364Z"
    />
  </>,
  "Sun"
);

export default Sun;
